import { c as _c } from "react/compiler-runtime";
import { connect } from 'react-redux';
import { FilterURI } from '@sbt-web/network/types';
import { FormGroup, Toggle } from '@sbt-web/ui';
import type { RootState } from '@/reducers/index';
import { updateQSO } from '@/reducers/search';
import { QSOLabel } from '@/tools/search/values';
import { FilterLabel } from '../common/FilterLabel';
import type { CommonFilterProps } from '../common/types';
import commonClasses from '../common/styles.module.scss';
type StateProps = {
  qso: boolean;
};
type DispatchProps = {
  updateQSO: (qso: boolean) => void;
};
type OwnProps = {
  trackSearchConversion: () => void;
};
type Props = CommonFilterProps & StateProps & DispatchProps & OwnProps;
export const QSOComponent = t0 => {
  const $ = _c(12);
  const {
    qso,
    showBadgeNew,
    trackSearchConversion,
    updateQSO
  } = t0;
  let t1;
  if ($[0] !== trackSearchConversion || $[1] !== updateQSO) {
    t1 = isSelected => {
      trackSearchConversion();
      updateQSO(isSelected);
    };
    $[0] = trackSearchConversion;
    $[1] = updateQSO;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleSelection = t1;
  let t2;
  if ($[3] !== showBadgeNew) {
    t2 = <FilterLabel showBadgeNew={showBadgeNew}>Restringi ricerca</FilterLabel>;
    $[3] = showBadgeNew;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [commonClasses["custom-toggle"]];
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== handleSelection || $[7] !== qso) {
    t4 = <Toggle name={FilterURI.QuerySubjectOnly} checked={qso} onInputChange={handleSelection} spaceBetweenElements={true} classes={t3}>{QSOLabel}</Toggle>;
    $[6] = handleSelection;
    $[7] = qso;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <FormGroup>{t2}{t4}</FormGroup>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export const QSOSelector = connect<StateProps, DispatchProps, OwnProps, RootState>((state: RootState, ownProps: OwnProps) => ({
  qso: state.search.qso,
  trackSearchConversion: ownProps.trackSearchConversion
}), dispatch => ({
  updateQSO: (qso: boolean) => dispatch(updateQSO(qso))
}))(QSOComponent);